import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import get from 'lodash.get';
import { FormattedMessage } from 'dibs-react-intl';
import { RingSizeDisplay } from '../../shared/components/RingSizeDisplay';
import styles from './styles/CheckoutSummaryItemSkuDetails.scss';

const CheckoutSummaryItemSkuDetailsComponent = ({ item, transaction, skipItemTitle }) => {
    const isRingItem = !!item?.isRingItem;
    const leadTime = get(transaction, 'sku.leadTime');
    const color = (get(transaction, 'skuVariableAttributeRows') || []).find(
        ({ label }) => label === 'Color'
    );

    return (
        <Fragment>
            {!skipItemTitle && (
                <div className={styles.labelContainer} data-tn="checkout-item-title">
                    {get(item, 'title')}
                </div>
            )}
            {isRingItem && <RingSizeDisplay item={item} transaction={transaction} />}
            {item.isMultiSku && !isRingItem && color && (
                <div className={styles.labelContainer}>
                    <span className={styles.label}>
                        <FormattedMessage
                            id="checkout.CheckoutSummaryItemSkuDetails.color"
                            defaultMessage="Color:"
                        />
                    </span>
                    {color.value}
                </div>
            )}
            {item.isMultiSku && leadTime && (
                <div className={styles.labelContainer}>
                    <span className={styles.label}>
                        <FormattedMessage
                            id="checkout.CheckoutSummaryItemSkuDetails.productionTime"
                            defaultMessage="Estimated Production Time:"
                        />
                    </span>
                    {leadTime}
                </div>
            )}
        </Fragment>
    );
};

CheckoutSummaryItemSkuDetailsComponent.propTypes = {
    item: PropTypes.object.isRequired,
    transaction: PropTypes.object.isRequired,
    skipItemTitle: PropTypes.bool,
};

export const CheckoutSummaryItemSkuDetails = createFragmentContainer(
    CheckoutSummaryItemSkuDetailsComponent,
    {
        item: graphql`
            fragment CheckoutSummaryItemSkuDetails_item on Item {
                ...RingSizeDisplay_item
                isMultiSku
                isRingItem
                title
            }
        `,
        transaction: graphql`
            fragment CheckoutSummaryItemSkuDetails_transaction on Transaction {
                ...RingSizeDisplay_transaction
                skuVariableAttributeRows {
                    label
                    value
                }
                sku {
                    leadTime(pageType: Checkout)
                }
            }
        `,
    }
);
